var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-type-switcher"},_vm._l((_vm.availableReportOptions),function(report){return _c('button',{key:report.value,class:{ active: report.value === _vm.selectedReport },on:{"click":function($event){return _vm.changeReport(report.value)}}},[_vm._v("\n    "+_vm._s(_vm.parseTranslation(report.value))+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }